import { EmailLinkSignInForm } from "@/features/auth/components/EmailLinkSignInForm";
import { caremeTheme } from "@/libs/theme";
import { Box, Link, Typography } from "@mui/material";
import { Container } from "@mui/system";
import NextLink from "next/link";
import { useRouter } from "next/router";

export function SigninWithEmail() {
	const router = useRouter();

	return (
		<Container component="main" maxWidth="xs" style={{ padding: 0 }}>
			<Box mt={6} px={6}>
				<Typography
					component="h1"
					variant="h6"
					textAlign="center"
					color={caremeTheme.palette.primary.main}
				>
					メールでログイン
				</Typography>
				<Typography mt={2} variant="body1" textAlign="center">
					本人確認済みのメールアドレスを
					<br />
					入力してください
				</Typography>

				<Box mt={2} width="100%">
					<EmailLinkSignInForm onSentEmail={() => router.push("email-sent")} />
				</Box>

				<Typography mt={3} variant="body2" textAlign="center">
					<Link
						component={NextLink}
						href="/signin-with-password"
						underline="none"
						typography="subtitle2"
						color={caremeTheme.palette.primary.main}
					>
						パスワードでログインする
					</Link>
				</Typography>

				<Typography
					mt={3}
					variant="body2"
					textAlign="center"
					color={caremeTheme.palette.grey[400]}
				>
					会員登録はアプリからのみできます
				</Typography>
			</Box>
		</Container>
	);
}
